/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_PAYMENT_QUEUE = gql`
  query GetQueueFromVQMS(
    $distCenter: UniqDistCentFilterInput!
    $queueType: QueueType!
  ) {
    getQueueFromVQMS(distCenter: $distCenter, queueType: $queueType) {
      parsed {
        band
        boxData {
          costumeID
          box_id
          delegateName
          email
          fullName
          masqID
        }
        createdOn
        distCent
        distCounterNo
        flowId
        isCalledByUser
        isCalledOutByDistCounter
        isCalledOutByPayCounter
        isDelegate
        isGroup
        isVipToken
        isMagicToken
        lockedByDistCounter
        lockedByPayCounter
        lockedByUser
        subQueue
        tokenKey
        payCounterNo
        vqmsQName
      }
    }
  }
`;
